var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('sb-staking')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('ste-staking')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('usdt-staking')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }